import { useCallback, FC } from "react";
import { useDropzone } from "react-dropzone";
import { BiImageAdd } from "react-icons/bi";
import { Wrapper } from "./DropZone.styled";
import ImageIcon from "common/icons/image";

type Props = {
  setFiles: any;
  files: object[];
  cropData: string;
};

const DropZone: FC<Props> = ({ setFiles, cropData, files }) => {
  const onDrop = useCallback(
    (acceptedFiles: any) => {
      setFiles(
        acceptedFiles.map((file: any) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
    [setFiles]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  if (cropData !== "#") {
    return null;
  }
  if (files[0]) {
    return null;
  }

  return (
    <Wrapper {...getRootProps()} isDragActive={isDragActive}>
      <input {...getInputProps()} />
      <ImageIcon />
      <p> Drag and drop </p>
      <p> or </p>
      <span>
        <p> Browse files</p>
      </span>
    </Wrapper>
  );
};

export default DropZone;
